"use client";

import { Vips } from "./components/vips";
import ProductsPostsEvents from "./components/products-posts-events";
import { HeroSection } from "./components/hero-section";
import HomeCommunitiesPopular from "@/modules/home/components/popular-tabs/tabs/home-communities-popular";
import BimDigitalTwinHome from "../../../adhoc/bim-homepage/bim-digital-twin-home";
import useCommunityAndChannelParams from "@/hooks/useChannelAndCommunityParams";
import GlobalFounder from "../../../adhoc/global-founder-homepage/GlobalFounder";

const Home = () => {
	const { communitySlug } = useCommunityAndChannelParams();

	if (communitySlug === "bim-digital-twin") {
		return <BimDigitalTwinHome />;
	}

	if (communitySlug === "global-proptech-founders") {
		return <GlobalFounder />;
	}

	return (
		<div>
			<HeroSection />
			<Vips />
			<HomeCommunitiesPopular />
			<ProductsPostsEvents />
		</div>
	);
};

export default Home;
